import { create } from "zustand";

const TaskStore = create((set) => ({
  copySelectedTask: null,

  setCopySelectedTask: (task) =>
    set({ copySelectedTask: task }),

  clearCopySelectedTask: () =>
    set({ copySelectedTask: null }),
}));

export default TaskStore;